"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
exports.view = view;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ReactRedux = __importStar(require("react-redux"));
const GraphQLTypes = __importStar(require("@genesys/graphql-types-tools"));
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Loaders = __importStar(require("@genesys/client-core/lib/loaders"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const Shared = __importStar(require("../shared/queries"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const product_validation_state_1 = require("./product-validation-state");
const export_text_issues_1 = require("../shared/export-text-issues");
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const Root = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
const SettingsContainer = styled_components_1.default.div `
  flex: 0 0 auto;
  padding: 20px;
  h3 {
    padding: 5px 0;
  }
  ul {
    li {
      padding: 5px;
    }
  }

  button {
    margin: 20px 0;
  }
`;
const VariantDataContainer = styled_components_1.default.div `
  padding: 20px;
  table {
    border: 1px solid #ddd;
    display: block;
    height: 300px;
    overflow: auto;
  }
`;
const LanguageContainer = styled_components_1.default.div `
  padding: 20px;
  table {
    border: 1px solid #ddd;
    display: block;
    height: 300px;
    overflow: auto;
  }
`;
const ResultContainer = styled_components_1.default.div `
  flex: 1 0 auto;
  button {
    margin: 20px 0;
  }
  textarea {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #ebebeb;
    box-sizing: border-box;
    resize: none;
  }
`;
const queryProducts = (0, graphql_tag_1.default) `
  query ProductValidationAllProducts {
    product {
      activeSystemTypes {
        id
        allProducts {
          id
        }
      }
      languages {
        id
      }
    }
  }
`;
const queryProductData = (0, graphql_tag_1.default) `
  query ProductValidationProductData($productInput: GetProductInputType!) {
    product {
      variantDataTableDefinitionsForProduct(input: $productInput) {
        id
        variantDataType
        tableName
      }

      billOfMaterialItemNosForProduct(input: $productInput)
      costOperationNosForProduct(input: $productInput)
      breakDownItemNosForProduct(input: $productInput)
    }
  }
`;
const getProductPreValidationResultQuery = (0, graphql_tag_1.default) `
  query ProductValidationPreValidationResult(
    $input: ProductValidationInputType!
  ) {
    product {
      getProductPreValidationResult(input: $input) {
        ok
        errors
      }
    }
  }
`;
const getBestPracticeWarningsQuery = (0, graphql_tag_1.default) `
  query ProductValidationBestPracticeWarnings(
    $input: ProductValidationInputType!
  ) {
    product {
      getProductBestPracticeWarnings(input: $input)
    }
  }
`;
const getGeneralErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationGeneralErrors($input: ProductValidationInputType!) {
    product {
      getProductGeneralErrors(input: $input)
    }
  }
`;
const getFilterErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationFilterErrors($input: ProductValidationInputType!) {
    product {
      getProductFilterErrors(input: $input)
    }
  }
`;
const getValueSourceUsageErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationValueSourceUsageErrors(
    $input: ProductValidationInputType!
  ) {
    product {
      getProductValueSourceUsageErrors(input: $input)
    }
  }
`;
const getCalculationMappingsErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationCalculationMappingsErrors(
    $input: ProductValidationInputType!
  ) {
    product {
      getProductCalculationMappingErrors(input: $input)
    }
  }
`;
const getCircularReferenceErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationCircularReferenceErrors(
    $input: ProductValidationInputType!
  ) {
    product {
      getProductCircularReferenceErrors(input: $input)
    }
  }
`;
const getPropertyUsageErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationPropertyUsageErrors(
    $input: ProductValidationInputType!
  ) {
    product {
      getProductPropertyUsageErrors(input: $input)
    }
  }
`;
const getCostOperationsErrorsForOperationNoQuery = (0, graphql_tag_1.default) `
  query ProductValidationCostOperationErrorsForOperationNo(
    $input: ProductCostValidationInputType!
  ) {
    product {
      getProductCostOperationsErrorsForOperationNo(input: $input)
    }
  }
`;
const getBillOfMaterialErrorsForItemNoQuery = (0, graphql_tag_1.default) `
  query ProductValidationBillOfMaterialErrorsForItemNo(
    $input: ProductCostValidationInputType!
  ) {
    product {
      getProductBillOfMaterialErrorsForItemNo(input: $input)
    }
  }
`;
const geBreakDownErrorsForBreakDownItemNoQuery = (0, graphql_tag_1.default) `
  query ProductValidationBreakDownErrorsForItemNo(
    $input: ProductCostValidationInputType!
  ) {
    product {
      getProductBreakDownErrorsForItemNo(input: $input)
    }
  }
`;
const getVariantDataTableErrorsQuery = (0, graphql_tag_1.default) `
  query ProductValidationVariantDataTableErrors(
    $input: VariantDataValidationInputType!
  ) {
    product {
      getProductVariantDataTableErrors(input: $input)
    }
  }
`;
const getProductPropertyTextIssuesQuery = (0, graphql_tag_1.default) `
  query ProductValidationProductPropertyTextIssues(
    $input: ProductTextValidationInputType!
  ) {
    product {
      getProductPropertyTextIssues(input: $input) {
        ...ProductPropertyTextIssueFragment
      }
    }
  }
  ${Shared.ProductTextFragment}
`;
const pleaseSelect = "please-select";
function view({ state, dispatch }) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProducts, variables: {} }, productData => {
        const activeSystemTypes = productData.product.activeSystemTypes
            .concat()
            .sort((a, b) => a.id.localeCompare(b.id));
        const availableLanguages = productData.product.languages
            .filter(l => l.id !== "xx-XX")
            .map(l => l.id)
            .sort((a, b) => a.localeCompare(b));
        return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(Loaders.PleaseWaitOverlayLoaderIndicator, { active: state.loading },
            React.createElement(Loaders.ProgressOverlayLoaderIndicator, { active: state.validationProgress.inProgress, message: state.validationProgress.message, current: state.validationProgress.current, max: state.validationProgress.max },
                React.createElement(Root, null,
                    React.createElement(SettingsContainer, null,
                        React.createElement(Elements.ExpanderWithArrow, { isCollapsed: state.filterCollapsed, onToggle: () => {
                                dispatch(product_validation_state_1.Action.ProductValidationToggleFilter());
                            }, text: "Filter" }),
                        !state.filterCollapsed && (React.createElement(React.Fragment, null,
                            React.createElement("h3", null,
                                React.createElement("p", null, "Hi! This is an experimental tool for validating a product. This is of course not a full check as new features are added every day, but it can be good for finding holes in the data at least. Have fun!"),
                                React.createElement("p", null, "NOTE 1 !!! It is highly recommended to follow the order below. !!!"),
                                React.createElement("p", null, "NOTE 2 !!! After fixing the data in Maintenance/Promaster, Reset cache to validate your freshly corrected data. !!!")),
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement(Elements.SelectBox, { value: state.settings.systemTypeId || pleaseSelect, onChange: e => {
                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { systemTypeId: e.target.value, productId: undefined, validateFilterErrors: false, validateValueSourceUsage: false, validateCalculationMappings: false, validateCircularReferences: false, validatePropertyUsage: false, validateBillOfMaterial: false, billOfMaterialItemNosToValidate: [], validateBreakDown: false, breakDownItemNosToValidate: [], validateOperations: false, costOperationNosToValidate: [], validatePropertyTexts: false, languagesToValidate: [], validateVariantData: false, variantDataTablesToValidate: [] })));
                                        } },
                                        React.createElement("option", { value: pleaseSelect }, "Please select"),
                                        activeSystemTypes
                                            .concat()
                                            .sort((a, b) => a.id.localeCompare(b.id))
                                            .map(p => (React.createElement("option", { key: p.id, value: p.id }, p.id)))),
                                    state.settings.systemTypeId && (React.createElement(React.Fragment, null,
                                        React.createElement(Elements.SelectBox, { value: state.settings.productId || pleaseSelect, onChange: e => {
                                                dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { productId: e.target.value, validateFilterErrors: false, validateValueSourceUsage: false, validateCalculationMappings: false, validateCircularReferences: false, validatePropertyUsage: false, validateBillOfMaterial: false, billOfMaterialItemNosToValidate: [], validateOperations: false, costOperationNosToValidate: [], validatePropertyTexts: false, languagesToValidate: [], validateVariantData: false, variantDataTablesToValidate: [] })));
                                            } },
                                            React.createElement("option", { value: pleaseSelect }, "Please select"),
                                            activeSystemTypes
                                                .flatMap(x => x.allProducts)
                                                .sort((a, b) => a.id.localeCompare(b.id))
                                                .filter(p => p.id.startsWith(state.settings.systemTypeId))
                                                .map(p => (React.createElement("option", { key: p.id, value: p.id }, p.id)))),
                                        React.createElement("label", null,
                                            "\u00A0SYS property value settings (will be used against Range Filters in the component):\u00A0",
                                            React.createElement("input", { type: "text", size: 50, disabled: false, value: state.settings.rangeProperties || "", onChange: e => {
                                                    dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { rangeProperties: e.target.value })));
                                                } }))))),
                                state.settings.systemTypeId &&
                                    state.settings.systemTypeId !== pleaseSelect &&
                                    state.settings.productId &&
                                    state.settings.productId !== pleaseSelect && (React.createElement(React.Fragment, null,
                                    React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProductData, variables: {
                                            productInput: {
                                                productId: state.settings.productId
                                            }
                                        } }, productData => {
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: true, type: "checkbox", checked: true }),
                                                    "1. Pre-validation. (Checks if inputs are ok and if all necessary components exists)")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: true, type: "checkbox", checked: true }),
                                                    "2. Best practices. (Best practice suggestions)")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: true, type: "checkbox", checked: true }),
                                                    "3. General error(s) and warnings(s). (Overview of unused and non-existent properties in the product definition)")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateFilterErrors, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateFilterErrors: !state.settings
                                                                    .validateFilterErrors })));
                                                        } }),
                                                    "4. Filter errors (Checks all validation filters, value validation filters etc, including Variant data fiters, for references to properties that does not exist on the product and source-properties)")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateValueSourceUsage, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateValueSourceUsage: !state.settings
                                                                    .validateValueSourceUsage })));
                                                        } }),
                                                    "5. Value source usage (Tries to find malformed value source references).")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateCalculationMappings, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateCalculationMappings: !state.settings
                                                                    .validateCalculationMappings })));
                                                        } }),
                                                    "6. Calculation mapping errors (Tries to find problematic Case- and Select- input- and outputmappings).")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateCircularReferences, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateCircularReferences: !state.settings
                                                                    .validateCircularReferences })));
                                                        } }),
                                                    "7. Circular reference (Detects circular reference within the product definition (validation filters, value validation filters, value sources and label filters) for example 'a depends on b which depends on c which depends on a'.")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validatePropertyUsage, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validatePropertyUsage: !state.settings
                                                                    .validatePropertyUsage })));
                                                        } }),
                                                    "8. Property usage (Detects usage in variant data tables where it is used indirectly via parameters, i.e. Reports and external interfaces like Report_TechnicalData, SolidContactInput, ErpSystems etc.)")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateBillOfMaterial, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateBillOfMaterial: !state.settings
                                                                    .validateBillOfMaterial, billOfMaterialItemNosToValidate: productData.product
                                                                    .billOfMaterialItemNosForProduct })));
                                                        } }),
                                                    "9. Bill of material (Checks for doubles per ItemNo represented in the product, also checks for malformed formulas), \u00A0",
                                                    productData.product
                                                        .billOfMaterialItemNosForProduct
                                                        .length,
                                                    "\u00A0 Bill of material ItemNo(s) to validate.")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateBreakDown, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateBreakDown: !state.settings
                                                                    .validateBreakDown, breakDownItemNosToValidate: productData.product
                                                                    .breakDownItemNosForProduct })));
                                                        } }),
                                                    "10. BreakDown (Checks for doubles per PartId, FromList pairing in the product, also checks for malformed formulas), \u00A0",
                                                    productData.product
                                                        .breakDownItemNosForProduct
                                                        .length,
                                                    "\u00A0 ItemNo(s) to validate.")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateOperations, onChange: () => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateOperations: !state.settings
                                                                    .validateOperations, costOperationNosToValidate: productData.product
                                                                    .costOperationNosForProduct })));
                                                        } }),
                                                    "11. Operations (Checks for doubles per OperationNo represented in the product, also checks for malformed formulas), \u00A0",
                                                    productData.product
                                                        .costOperationNosForProduct
                                                        .length,
                                                    "\u00A0OperationNo(s) to validate.")),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings
                                                            .systemTypeId ===
                                                            undefined ||
                                                            state.settings
                                                                .systemTypeId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validatePropertyTexts, onChange: () => {
                                                            let languages = [];
                                                            if (!state.settings
                                                                .validatePropertyTexts) {
                                                                dispatch(product_validation_state_1.Action.ProductValidationSetShowLanguages(true));
                                                                languages =
                                                                    product_validation_state_1.defaultLanguages;
                                                            }
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validatePropertyTexts: !state.settings
                                                                    .validatePropertyTexts, languagesToValidate: languages })));
                                                        } }),
                                                    "12. Tries to find issues with product property and product property value translations on the product level. It will add warnings for missing/multiple and text type for [productId, propertyName]- and [productId, propertyName, propertyValue] translations.")),
                                            state.settings.systemTypeId &&
                                                state.settings.systemTypeId !==
                                                    pleaseSelect &&
                                                state.settings.productId &&
                                                state.settings.productId !==
                                                    pleaseSelect &&
                                                state.settings
                                                    .validatePropertyTexts && (React.createElement(LanguageContainer, null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings
                                                            .systemTypeId ===
                                                            undefined ||
                                                            state.settings
                                                                .systemTypeId ===
                                                                pleaseSelect ||
                                                            !state.settings
                                                                .validatePropertyTexts, type: "checkbox", checked: state.showLangugagesList, onChange: e => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetShowLanguages(e.target.checked));
                                                        } }),
                                                    "Show language selections"),
                                                state.showLangugagesList && (React.createElement(React.Fragment, null,
                                                    React.createElement(React.Fragment, null,
                                                        React.createElement(Elements.StandardButton, { onClick: () => {
                                                                dispatch(product_validation_state_1.Action.ProductValidationCheckAllLanguages(availableLanguages));
                                                            } }, "Check all"),
                                                        React.createElement(Elements.StandardButton, { onClick: () => {
                                                                dispatch(product_validation_state_1.Action.ProductValidationUnCheckAllLanguages());
                                                            } }, "Clear all"),
                                                        React.createElement(Elements.StandardButton, { onClick: () => {
                                                                dispatch(product_validation_state_1.Action.ProductValidationCheckDefaultLanguages());
                                                            } }, "Default"),
                                                        React.createElement("table", null, availableLanguages.map(al => {
                                                            const tablestate = state.settings.languagesToValidate.find(l => l === al);
                                                            const checked = tablestate !==
                                                                undefined;
                                                            return (React.createElement("tr", { key: al },
                                                                React.createElement("td", null,
                                                                    React.createElement("label", null,
                                                                        React.createElement("input", { type: "checkbox", checked: checked, onChange: () => {
                                                                                dispatch(product_validation_state_1.Action.ProductValidationToggleSelectedLanguages(al));
                                                                            } }))),
                                                                React.createElement("td", null, al)));
                                                        }))))))),
                                            React.createElement("li", null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings.productId ===
                                                            undefined ||
                                                            state.settings.productId ===
                                                                pleaseSelect, type: "checkbox", checked: state.settings
                                                            .validateVariantData, onChange: () => {
                                                            if (!state.settings
                                                                .validateVariantData) {
                                                                dispatch(product_validation_state_1.Action.ProductValidationSetShowVariantData(true));
                                                            }
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { validateVariantData: !state.settings
                                                                    .validateVariantData, variantDataTablesToValidate: [] })));
                                                        } }),
                                                    "13. Variant data (Validates if the variant data tables listed yields the correct amount of valid rows, also lists invalid rows.)")),
                                            state.settings.productId &&
                                                state.settings.productId !==
                                                    pleaseSelect &&
                                                state.settings
                                                    .validateVariantData && (React.createElement(VariantDataContainer, null,
                                                React.createElement("label", null,
                                                    React.createElement("input", { disabled: state.settings
                                                            .productId ===
                                                            undefined ||
                                                            state.settings
                                                                .productId ===
                                                                pleaseSelect ||
                                                            !state.settings
                                                                .validateVariantData, type: "checkbox", checked: state.showVariantDataList, onChange: e => {
                                                            dispatch(product_validation_state_1.Action.ProductValidationSetShowVariantData(e.target.checked));
                                                        } }),
                                                    "Show variant data validation selections"),
                                                state.showVariantDataList && (React.createElement(React.Fragment, null,
                                                    React.createElement("p", null, "Why are some tables disabled for validation?"),
                                                    React.createElement("p", null, "The variant data tables are validated according to their specified type. A validation is not possible if the type is undefined."),
                                                    React.createElement(React.Fragment, null,
                                                        React.createElement(Elements.StandardButton, { onClick: () => {
                                                                dispatch(product_validation_state_1.Action.ProductValidationCheckAllVariantDataTables(productData
                                                                    .product
                                                                    .variantDataTableDefinitionsForProduct));
                                                            } }, "Check all"),
                                                        React.createElement(Elements.StandardButton, { onClick: () => {
                                                                dispatch(product_validation_state_1.Action.ProductValidationUnCheckAllVariantDataTables());
                                                            } }, "Clear all"),
                                                        React.createElement("input", { type: "checkbox", checked: state.showUndefinedVariantDataTables, onChange: () => {
                                                                dispatch(product_validation_state_1.Action.ProductValidationToggleShowUndefined());
                                                            } }),
                                                        React.createElement("label", null, "Show undefined"),
                                                        React.createElement("table", null, productData.product.variantDataTableDefinitionsForProduct
                                                            .concat()
                                                            .filter(v => state.showUndefinedVariantDataTables ||
                                                            (!state.showUndefinedVariantDataTables &&
                                                                v.variantDataType !==
                                                                    GraphQLTypes
                                                                        .VariantDataType
                                                                        .UNDEFINED))
                                                            .sort((a, b) => {
                                                            if (a.variantDataType ===
                                                                b.variantDataType) {
                                                                return 0;
                                                            }
                                                            else if (a.variantDataType !==
                                                                GraphQLTypes
                                                                    .VariantDataType
                                                                    .UNDEFINED &&
                                                                b.variantDataType ===
                                                                    GraphQLTypes
                                                                        .VariantDataType
                                                                        .UNDEFINED) {
                                                                return -1;
                                                            }
                                                            else if (a.variantDataType ===
                                                                GraphQLTypes
                                                                    .VariantDataType
                                                                    .UNDEFINED &&
                                                                b.variantDataType !==
                                                                    GraphQLTypes
                                                                        .VariantDataType
                                                                        .UNDEFINED) {
                                                                return 1;
                                                            }
                                                            return 0;
                                                        })
                                                            .map(t => {
                                                            const tablestate = state.settings.variantDataTablesToValidate.find(vdtv => vdtv.tableName ===
                                                                t.tableName);
                                                            const checked = tablestate !==
                                                                undefined;
                                                            const filter = tablestate &&
                                                                tablestate.filter;
                                                            return (React.createElement("tr", { key: t.id },
                                                                React.createElement("td", null,
                                                                    React.createElement("label", null,
                                                                        React.createElement("input", { type: "checkbox", disabled: t.variantDataType ===
                                                                                GraphQLTypes
                                                                                    .VariantDataType
                                                                                    .UNDEFINED, checked: checked, onChange: () => {
                                                                                dispatch(product_validation_state_1.Action.ProductValidationToggleSelectedVariantDataTables(t.tableName));
                                                                            } }))),
                                                                React.createElement("td", null, t.tableName),
                                                                React.createElement("td", null, t.variantDataType),
                                                                React.createElement("td", null,
                                                                    React.createElement("input", { type: "text", size: 50, disabled: !checked, value: filter ||
                                                                            "", onChange: e => {
                                                                            dispatch(product_validation_state_1.Action.ProductValidationSetVariantDataFilter(t.tableName, e
                                                                                .target
                                                                                .value));
                                                                        } }))));
                                                        })))))))));
                                    })))),
                            React.createElement(Elements.StandardButton, { disabled: state.settings.productId === undefined ||
                                    state.settings.productId === pleaseSelect, onClick: async () => {
                                    dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Initialize", 0, 0));
                                    dispatch(product_validation_state_1.Action.ProductValidationSetResult([]));
                                    const systemTypeId = state.settings.systemTypeId;
                                    const productId = state.settings.productId;
                                    const rangeProperties = state.settings.rangeProperties || "";
                                    const variantDataTablesToValidate = state.settings
                                        .validateVariantData
                                        ? state.settings.variantDataTablesToValidate
                                        : [];
                                    let numberOfSteps = 3;
                                    if (state.settings.validateFilterErrors) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validatePropertyUsage) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateValueSourceUsage) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateCalculationMappings) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateCircularReferences) {
                                        numberOfSteps++;
                                    }
                                    if (state.settings.validateBillOfMaterial) {
                                        numberOfSteps +=
                                            state.settings.billOfMaterialItemNosToValidate
                                                .length;
                                    }
                                    if (state.settings.validateBreakDown) {
                                        numberOfSteps +=
                                            state.settings.breakDownItemNosToValidate
                                                .length;
                                    }
                                    if (state.settings.validateOperations) {
                                        numberOfSteps +=
                                            state.settings.costOperationNosToValidate
                                                .length;
                                    }
                                    if (state.settings.validatePropertyTexts) {
                                        numberOfSteps++;
                                    }
                                    numberOfSteps +=
                                        variantDataTablesToValidate.length;
                                    const messages = [];
                                    let current = 1;
                                    dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Pre validation", current, numberOfSteps));
                                    const preValidationResult = await getPreValidationResult(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                    messages.push(...preValidationResult.product
                                        .getProductPreValidationResult.errors);
                                    if (!preValidationResult.product
                                        .getProductPreValidationResult.ok) {
                                        dispatch(product_validation_state_1.Action.ProductValidationSetResult(messages));
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(false, "", 0, 0));
                                        dispatch(product_validation_state_1.Action.ProductValidationHideFilter());
                                        return;
                                    }
                                    current++;
                                    dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Best practice warnings", current, numberOfSteps));
                                    const bestPracticeWarnings = await getBestPracticeWarnings(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                    messages.push(...bestPracticeWarnings.product
                                        .getProductBestPracticeWarnings);
                                    current++;
                                    dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "General errors", current, numberOfSteps));
                                    const generalErrors = await getGeneralErrors(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                    messages.push(...generalErrors.product.getProductGeneralErrors);
                                    if (state.settings.validateFilterErrors) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Filter errors", current, numberOfSteps));
                                        const filterErrors = await getFilterErrors(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...filterErrors.product.getProductFilterErrors);
                                    }
                                    if (state.settings.validateValueSourceUsage) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Value source usage errors", current, numberOfSteps));
                                        const valueSourceUsageErrors = await getValueSourceUsageErrors(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...valueSourceUsageErrors.product
                                            .getProductValueSourceUsageErrors);
                                    }
                                    if (state.settings.validateCalculationMappings) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Calculation mapping errors", current, numberOfSteps));
                                        const calculationMappingErrors = await getCalculationMappingErrors(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...calculationMappingErrors.product
                                            .getProductCalculationMappingErrors);
                                    }
                                    if (state.settings.validateCircularReferences) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Circular reference errors", current, numberOfSteps));
                                        const circularReferenceErrors = await getCircularReferenceErrors(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...circularReferenceErrors.product
                                            .getProductCircularReferenceErrors);
                                    }
                                    if (state.settings.validatePropertyUsage) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Property usage errors", current, numberOfSteps));
                                        const propertyUsageErrors = await getPropertyUsageErrors(systemTypeId, productId, rangeProperties, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...propertyUsageErrors.product
                                            .getProductPropertyUsageErrors);
                                    }
                                    if (state.settings.validateBillOfMaterial) {
                                        for (const itemNo of state.settings
                                            .billOfMaterialItemNosToValidate) {
                                            current++;
                                            dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, `Bill of material errors for itemNo: ${itemNo}.`, current, numberOfSteps));
                                            const billOfMaterialErrorsForItemNo = await getBillOfMaterialErrorsForItemNo(systemTypeId, productId, rangeProperties, itemNo, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                            messages.push(...billOfMaterialErrorsForItemNo.product
                                                .getProductBillOfMaterialErrorsForItemNo);
                                        }
                                    }
                                    if (state.settings.validateBreakDown) {
                                        for (const breakDownItemNo of state.settings
                                            .breakDownItemNosToValidate) {
                                            current++;
                                            dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, `BreakDown errors for itemNo: ${breakDownItemNo}.`, current, numberOfSteps));
                                            const breakDownErrorsForItemNo = await getBreakDownErrorsForBreakDownItemNo(systemTypeId, productId, rangeProperties, breakDownItemNo, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                            messages.push(...breakDownErrorsForItemNo.product
                                                .getProductBreakDownErrorsForItemNo);
                                        }
                                    }
                                    if (state.settings.validateOperations) {
                                        for (const operationNo of state.settings
                                            .costOperationNosToValidate) {
                                            current++;
                                            dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, `Cost operation errors for itemNo: ${operationNo}.`, current, numberOfSteps));
                                            const costOperationErrorsForOperationNo = await getCostOperationsErrorsForOperationNo(systemTypeId, productId, rangeProperties, operationNo, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                            messages.push(...costOperationErrorsForOperationNo.product
                                                .getProductCostOperationsErrorsForOperationNo);
                                        }
                                    }
                                    if (state.settings.validatePropertyTexts) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Validate Property/PropertyValue texts", current, numberOfSteps));
                                        const productPropertyTextIssues = await getProductPropertyTextIssues(systemTypeId, productId, state.settings.languagesToValidate, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...productPropertyTextIssues.product
                                            .getProductPropertyTextIssues.errorReport);
                                        dispatch(product_validation_state_1.Action.SetTextIssues(productPropertyTextIssues.product
                                            .getProductPropertyTextIssues.issues));
                                    }
                                    for (const table of variantDataTablesToValidate) {
                                        current++;
                                        dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(true, "Variant data table errors: " +
                                            table.tableName, current, numberOfSteps));
                                        const variantDataTableErrors = await getVariantDataTableErrors(systemTypeId, productId, rangeProperties, table.tableName, table.filter, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                        messages.push(...variantDataTableErrors.product
                                            .getProductVariantDataTableErrors);
                                    }
                                    dispatch(product_validation_state_1.Action.ProductValidationSetResult(messages));
                                    dispatch(product_validation_state_1.Action.ProductValidationSetValidationProgress(false, "", 0, 0));
                                    dispatch(product_validation_state_1.Action.ProductValidationHideFilter());
                                } }, "Validate"),
                            React.createElement("label", null,
                                "\u00A0Show only errors",
                                React.createElement("input", { type: "checkbox", checked: state.settings.errorsOnly, onChange: () => {
                                        dispatch(product_validation_state_1.Action.ProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { errorsOnly: !state.settings.errorsOnly })));
                                    } }))))),
                    React.createElement(ResultContainer, null,
                        React.createElement(Exporter.XlsxSingleSheetExport, { data: getDataAsTable(state.messages), filename: state.settings.productId +
                                +" - Product validation results" }, onClick => (React.createElement(Elements.StandardButton, { disabled: state.messages.length === 0, onClick: onClick }, "Export"))),
                        React.createElement(export_text_issues_1.ExportTextIssues, { data: state.issues, disabled: state.messages.length === 0, fileName: `${state.settings.productId}-text-issues` }),
                        state.messages.length > 1000 ? (React.createElement(React.Fragment, null,
                            " ",
                            "Displaying only 1000 rows. Use excel export for the rest.")) : (React.createElement(React.Fragment, null)),
                        React.createElement("textarea", { readOnly: true, value: state.messages
                                .slice(0, Math.min(1000, state.messages.length))
                                .join("\n") }))))))));
    }));
}
function getDataAsTable(messages) {
    return messages.map(v => {
        const row = [];
        row.push(v);
        return row;
    });
}
function getPreValidationResult(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getProductPreValidationResultQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getBestPracticeWarnings(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getBestPracticeWarningsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getGeneralErrors(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getGeneralErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getFilterErrors(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getFilterErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getValueSourceUsageErrors(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getValueSourceUsageErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getCalculationMappingErrors(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getCalculationMappingsErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getCircularReferenceErrors(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getCircularReferenceErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getPropertyUsageErrors(systemTypeId, productId, rangeProperties, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getPropertyUsageErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getBillOfMaterialErrorsForItemNo(systemTypeId, productId, rangeProperties, costId, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getBillOfMaterialErrorsForItemNoQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            costId: costId,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getBreakDownErrorsForBreakDownItemNo(systemTypeId, productId, rangeProperties, costId, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(geBreakDownErrorsForBreakDownItemNoQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            costId: costId,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getCostOperationsErrorsForOperationNo(systemTypeId, productId, rangeProperties, costId, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getCostOperationsErrorsForOperationNoQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            costId: costId,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getVariantDataTableErrors(systemTypeId, productId, rangeProperties, tableName, filter, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getVariantDataTableErrorsQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties,
            tableName: tableName,
            filter: filter,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
function getProductPropertyTextIssues(systemTypeId, productId, languages, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getProductPropertyTextIssuesQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            languages: languages,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
exports.View = ReactRedux.connect((state) => ({ state: state.ui.productValidation }))(view);
//# sourceMappingURL=product-validation-view.js.map